var map = {
	"./Beijing/index.js": [
		2417,
		417
	],
	"./New York/index.js": [
		6188,
		188
	],
	"./Norway/index.js": [
		8932,
		551
	],
	"./Yiwu/index.js": [
		5999,
		999
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1774;
module.exports = webpackAsyncContext;